import React from 'react';
import styled from 'styled-components';
import { OSKLogoSolid } from '../assets/OSKLogo';
import { BoxProps } from '../Box';

type HeaderProps = {
    className?: string;
    children?: React.ReactNode;
    logo?: React.SVGProps<SVGSVGElement>;
    onLogoClick?: () => void;
} & Omit<BoxProps, 'ref'>;

const CoreHeader = ({ className, children, logo = OSKLogoSolid, onLogoClick, ...props }: HeaderProps) => {
    return (
        <div className={className} {...props}>
            {children}
        </div>
    );
};

CoreHeader.defaultProps = {};

const Header = styled(CoreHeader)`
    display: flex;
    flex-direction: row;
    flex-shrink: 1;
    align-items: center;
    background-color: ${(props: any) => props.theme.colors.primary.bg};
    color: ${(props: any) => props.theme.colors.primary.fg};
    padding: 6px ${(props: any) => props.theme.edgeContentPadding}px;
`;

export type { HeaderProps };
export { Header };
